"use client";

import trackClevertapEvents from "@/utils/trackClevertapEvents";
import "@monsterindia/global-ui-components/dist/styles.css";
// import DownloadApp from "@/components/common/defaultHeader/DownloadAppBanner";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

import { currentQueryParams } from "../constants/ProfileFields";
import { SETTINGS_TABS, SETTINGS_TABS_LABEL } from "../contents/constants";
import LeftSideBar from "../navigation/LeftSideBar";
import NavigationTopLabel from "../navigation/NavigationTopLabel";
import RightSideBanners from "../rightSideBanner";
import ActiveTabComponent from "./activeTabComponent";
import { fetchAutoApply } from "./utils/fetchAutoApply";

const DownloadApp = dynamic(
  () => import("@/components/common/defaultHeader/DownloadAppBanner"),
  { ssr: false },
);

export default function SettingPage({
  selectedTab,
  isMobile,
  headerParam,
}: {
  selectedTab: string;
  isMobile: boolean;
  headerParam: boolean | string;
}) {
  const router = useRouter();

  const currentTab = selectedTab?.length
    ? selectedTab
    : isMobile
      ? ""
      : "profile";

  const [activeTab, setActiveTab] = useState<string>(currentTab);
  const [activeLabel, setActiveLabel] = useState<string>("");
  const [showDownloadAppCta, setShowDownloadAppCta] = useState(true);

  const [autoApplyData, setAutoApplyData] = useState<any>(null);
  const [autoApplyLoading, setAutoApplyLoading] = useState(true);

  useEffect(() => {
    const getAutoApplyData = async () => {
      try {
        const data = await fetchAutoApply();

        setAutoApplyData(data);
      } catch (error) {
        console.error("Failed to fetch Auto Apply data:", error);
      } finally {
        setAutoApplyLoading(false);
      }
    };

    getAutoApplyData();
  }, []);

  const status = autoApplyData?.auto_apply_status?.status;

  const showAutoApply =
    !autoApplyLoading && (status === "ACTIVE" || status === "INACTIVE");

  const getLabelFromTab = (tab: string): string => {
    for (let key in SETTINGS_TABS) {
      if (SETTINGS_TABS[key as keyof typeof SETTINGS_TABS].name === tab) {
        return SETTINGS_TABS[key as keyof typeof SETTINGS_TABS].label;
      }
    }
    return "";
  };

  useEffect(() => {
    let search = window.location.search;
    let urlParams = new URLSearchParams(search);
    let utm_campaign = urlParams.get("utm_campaign");
    let utm_medium = urlParams.get("utm_medium");
    let utm_source = urlParams.get("utm_source");
    let utm_content = urlParams.get("utm_content");
    let utm_term = urlParams.get("utm_term");
    const DEFAULT_TAB = SETTINGS_TABS.PROFILE.name;
    trackClevertapEvents.eventPush("PageViewed", {
      utm_campaign,
      utm_medium,
      utm_source,
      utm_content,
      utm_term,
    });
    if (isMobile) {
      const currentQueryParams = new URLSearchParams(window.location.search);
      router.push(`?${currentQueryParams.toString()}`);
      const isValidTab = SETTINGS_TABS_LABEL.includes(currentTab);
      const activeTabName = isValidTab ? currentTab : "";
      const getLabelFromTab = (tab: string): string => {
        for (let key in SETTINGS_TABS) {
          if (SETTINGS_TABS[key as keyof typeof SETTINGS_TABS].name === tab) {
            return SETTINGS_TABS[key as keyof typeof SETTINGS_TABS].label;
          }
        }
        return "";
      };
      const activeLabelName: string = isValidTab
        ? getLabelFromTab(currentTab)
        : "";
      setActiveLabel(activeLabelName);
      setActiveTab(activeTabName);
    } else {
      if (currentTab) {
        const isValidTab = SETTINGS_TABS_LABEL.includes(currentTab);
        const activeTabName = isValidTab ? currentTab : DEFAULT_TAB;
        setActiveLabel("");
        setActiveTab(activeTabName);
        const currentQueryParams = new URLSearchParams(window.location.search);
        currentQueryParams.set("activeTab", currentTab);
        router.push(`?${currentQueryParams.toString()}`);
      }
    }
  }, [isMobile]);

  useEffect(() => {
    const handlePopState = () => {
      const currentQueryParams = new URLSearchParams(window.location.search);
      const newTab = currentQueryParams.get("activeTab") || "";

      if (newTab && SETTINGS_TABS_LABEL.includes(newTab)) {
        setActiveTab(newTab);
        setActiveLabel(getLabelFromTab(newTab));
      } else {
        setActiveTab("");
        setActiveLabel("");
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  useEffect(() => {
    const pageName = window.location.pathname;
    if (
      pageName.includes("/profile") ||
      pageName.includes("profileSettings") ||
      headerParam === "false"
    ) {
      setShowDownloadAppCta(false);
    } else {
      setShowDownloadAppCta(true);
    }
  }, []);

  return (
    <div id="setting-page" className="mx-auto max-w-[1188px]">
      <div>
        {!activeLabel?.length && isMobile ? (
          <>
            <NavigationTopLabel
              isMobile={isMobile}
              activeLabel={activeLabel}
              setActiveLabel={setActiveLabel}
              currentQueryParams={currentQueryParams}
            />{" "}
          </>
        ) : (
          <NavigationTopLabel
            isMobile={isMobile}
            activeLabel={activeLabel}
            setActiveLabel={setActiveLabel}
            currentQueryParams={currentQueryParams}
          />
        )}
        <div className="md:flex">
          {!activeLabel && (
            <LeftSideBar
              isMobile={isMobile}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              setActiveLabel={setActiveLabel}
              currentQueryParams={currentQueryParams}
              showAutoApply={showAutoApply}
            />
          )}
          <ActiveTabComponent
            isMobile={isMobile}
            activeLabel={activeLabel}
            activeTab={activeTab}
            autoApplyData={autoApplyData}
          />
          {!isMobile ? <RightSideBanners /> : null}
          {showDownloadAppCta && (
            <DownloadApp isMobile={isMobile} activeLabel={activeLabel} />
          )}
        </div>
      </div>
    </div>
  );
}
